'use es6';

export const CREATE_MENU = 'CREATE_MENU';
export const DELETE_MENU = 'DELETE_MENU';
export const FETCH_MENUS = 'FETCH_MENUS';
export const PUBLISH_MENU = 'PUBLISH_MENU';
export const SELECT_MENU = 'SELECT_MENU';
export const RENAME_MENU = 'RENAME_MENU';
export const CLONE_MENU = 'CLONE_MENU';
export const MENU_FETCH_REVISIONS = 'MENU_FETCH_REVISIONS';
export const REVERT_MENU = 'REVERT_MENU';
export const MENU_NOTIFICATION = 'MENU_NOTIFICATION';
export const DISCARD_MENU_BUFFER = 'DISCARD_MENU_BUFFER';
export const FETCH_MENU_BUFFER = 'FETCH_MENU_BUFFER';
export const SAVE_MENU_BUFFER = 'SAVE_MENU_BUFFER';
export const SET_AUTH = 'SET_AUTH';